import React from "react";
import {LinearProgress, Typography} from "@mui/material";
import {CompanyLogo} from "@atttomyx/react-components";
import Logo from "./logo";
import {milesoft} from "@atttomyx/shared-constants";
import "./splash.css";

const Splash = (props) => {
    const { percent } = props;
    const showPercent = percent !== undefined && percent !== null && percent >= 0 && percent <= 100;

    return <div className="splash">
        <div className="wrapper">
            <div className="splash-logo">
                <Logo/>
            </div>
            <LinearProgress
                color="primary"
                value={showPercent ? percent : null}
                valueBuffer={showPercent ? 100 - percent : null}
                variant={showPercent ? "determinate" : "indeterminate"}
            />
            <div className="poweredBy">
                <Typography variant="caption">
                    Powered by
                </Typography>
                <CompanyLogo mode="logo" size="small"/>
                <Typography variant="caption">
                    {milesoft.COMPANY_WEBSITE}
                </Typography>
            </div>
        </div>
    </div>
};

export default Splash;
